import SiteContentTable from "@/app/app-shared/site-content/site-content-table";

export default function SiteContentListingPage() {
  return <SiteContentTable />;
}
